import 'src/app/shared/snackbar-guard';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginComponent } from './auth/login/login.component';
import { MainComponent } from './master/main/main.component';
import { DashboardComponent } from './master/dashboard/dashboard.component';


import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';


import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LayoutModule } from '@angular/cdk/layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { CardsModule } from './cards/cards.module';
import { routes } from './app-routing.module';
import { provideNgxWebstorage, withLocalStorage, withSessionStorage } from 'ngx-webstorage';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { BidiModule } from '@angular/cdk/bidi';
import { OptionsModule } from './options/options.module';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { retry } from 'rxjs/operators';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatspinnerComponent } from './auth/matspinner/matspinner.component';
import { ReportsModule } from './reports/reports.module';
import { RoleGuard } from './role.guard';
import { AuthGuard } from './auth/auth.guard';
import { AuthService } from './auth/auth.service';
import { MatBadgeModule } from '@angular/material/badge';
import { ResetpasswordComponent } from './auth/resetpassword/resetpassword.component';
import { SystemsettingsModule } from './systemsettings/systemsettings.module';
import { EFawateercomModule } from './e-fawateercom/e-fawateercom.module';
import { GoodcardintcInterceptor } from './goodcardintc.interceptor';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';


// A language file that fails to load once (e.g. while ng serve rebuilds) left
// every label as its raw key until a manual refresh; retry it a few times first.
class RetryTranslateLoader implements TranslateLoader {
  private inner: TranslateHttpLoader;
  constructor(http: HttpClient) {
    this.inner = new TranslateHttpLoader(http);
  }
  getTranslation(lang: string) {
    return this.inner.getTranslation(lang).pipe(retry({ count: 3, delay: 800 }));
  }
}

export function httpTranslateLoader(http: HttpClient) {
  return new RetryTranslateLoader(http);
}

@NgModule({ declarations: [
        AppComponent,
        LoginComponent,
        MainComponent,
        DashboardComponent,
        MatspinnerComponent,
        ResetpasswordComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forRoot(routes, { useHash: true }),
        OptionsModule,
        ReportsModule,
        SystemsettingsModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        BrowserAnimationsModule,
        LayoutModule,
        MatToolbarModule,
        MatSidenavModule,
        MatIconModule,
        MatListModule,
        MatMenuModule,
        MatExpansionModule,
        MatCardModule,
        MatDatepickerModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatSnackBarModule,
        BidiModule,
        MatBadgeModule,
        TranslateModule.forRoot({
            defaultLanguage: 'ar',
            loader: {
                provide: TranslateLoader,
                useFactory: httpTranslateLoader,
                deps: [HttpClient],
            }
        }),
        CardsModule,
        EFawateercomModule], providers: [
        // local / session storage (same key format as before, so saved logins stay)
        provideNgxWebstorage(withLocalStorage(), withSessionStorage()),
        AuthService, RoleGuard, AuthGuard,
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline', subscriptSizing: 'dynamic' } },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: GoodcardintcInterceptor,
            multi: true
        }, provideHttpClient(withInterceptorsFromDi()),] })
export class AppModule { }
